// 管理后台出站 x-api-key：runtime-config.js 优先（部署时改写，产物不内嵌密钥）。
// 构建期注入的 VUE_APP_API_KEY 若是占位符（build-placeholder），绝不能短路真配置——
// 线上曾因 DefinePlugin 把它烧成字面量导致所有请求 403。
export function getApiKey() {
  const rc = (typeof window !== 'undefined' && window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.API_KEY) || ''
  if (rc && rc !== 'build-placeholder') return rc
  const built = process.env.VUE_APP_API_KEY || ''
  if (built && built !== 'build-placeholder') return built
  return ''
}
